module.exports = __webpack_public_path__ + "school/img/tishi.1d0e3a67.png";